import { render, staticRenderFns } from "./nutritionSales.vue?vue&type=template&id=6ef41fae"
import script from "./nutritionSales.vue?vue&type=script&lang=js"
export * from "./nutritionSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports